
const state = () => ({
  /**
   * Help dialog visibility.
   * @type Boolean
   */
  show: false,

  /**
   * QuickGuide step value.
   * @type Number
   */
  quickGuide: null,
})

const getters = {}

const mutations = {
  show (state) {
    state.show = true
  },
  hide (state) {
    state.quickGuide = null
    state.show = false
  },
  quickGuide (state, v = 0) {
    state.quickGuide = v
  },
}

const actions = {
  open ({ commit }) {
    setTimeout(() => commit('show'), 150)
  },
  close ({ commit }) {
    commit('hide')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
